import { render } from "./CodeInput.vue?vue&type=template&id=28fe9936"
import script from "./CodeInput.vue?vue&type=script&lang=js"
export * from "./CodeInput.vue?vue&type=script&lang=js"
script.render = render

export default script